import { useState, useContext, useEffect, ChangeEvent, FC } from 'react';
import Image from 'next/image';

import { assetsPath } from 'Data/constants';
import { NavContext } from 'Context/nav-context';

import styles from './search-bar.module.scss';
import { useIntl } from 'react-intl';
import { getBannerHostUrl } from '@/utils';

interface ISearchBarProps {
  categories?: any[];
}
export const setPopUpClass = (result: [], setPopup: any) => {
  if (result.length) {
    setPopup({ display: 'block' });
  } else {
    setPopup({ display: 'none' });
  }
};

const SearchBar: FC<ISearchBarProps> = ({ categories = [] }) => {
  const { searchText } = useContext(NavContext);
  const [showPopup, setPopup] = useState<{ display: string }>({ display: 'block' });
  const [searchResult, setSearchResult] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>(searchText || '');

  const { formatMessage } = useIntl();

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);

    if (event.target.value === '') return null;
    const result: any = categories.filter((item: any) => {
      return item.L2L3.toLowerCase().includes(event.target.value.toLowerCase());
    });
    setSearchResult(result);
    setPopUpClass(result, setPopup);
  };

  useEffect(() => {
    setSearchValue(searchText);
  }, [searchText]);

  return (
    <div className={styles.lvl0NavSearch}>
      <form
        id="nav-search"
        className={styles.level1NavSearchForm}
        action={`${getBannerHostUrl()}/search?text=${searchValue}`}
        autoComplete="off"
        noValidate={true}
      >
        <input
          type="text"
          name="text"
          placeholder={formatMessage({ id: 'search' })}
          tabIndex={0}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e)}
          onBlur={() => {
            setPopup({ display: 'none' });
          }}
          aria-label={formatMessage({ id: 'search' })}
          value={searchValue}
        />
        <button data-testid="link-container" type="submit" aria-label={formatMessage({ id: 'search' })}>
          <Image
            src={`${assetsPath}/site-icons/2020-site-icons/ico-search.svg`}
            alt={formatMessage({ id: 'search' })}
            width={18}
            height={28}
          />
        </button>
      </form>
      <div className={styles.lvl0NavSearchDesktopPopup} style={showPopup}>
        {searchResult.map((result: any) => (
          <button key={result.L2L3} className={styles.searchPopupMbSearch} aria-label={'searchInBeauty'} tabIndex={0}>
            <div className={styles.searchPopupText}>
              <p>{result.L2L3}</p>
            </div>
            <div>
              {result.L0} / {result.L1}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;
